"use client"

import { toImageSrc } from "@/lib/utils"
import { CompanyValue } from "@/types/types"
import Image from "next/image"
import { CompanyValueItem } from "./CompanyValueItem"

interface BottomSectionProps {
  image?: string
  visionTitle?: string
  visionDescription?: string
  missionTitle?: string
  missionDescription?: string
  companyValues?: CompanyValue[]
  className?: string
}

export const BottomSection = ({
  image,
  visionTitle,
  visionDescription,
  missionTitle,
  missionDescription,
  companyValues,
  className = "",
}: BottomSectionProps) => {
  const imageUrl = image ? toImageSrc(image) : null

  return (
    <div className={`bg-[#FAFAFB] relative ${className}`}>
      <div className="container mx-auto max-w-[1260px] px-4 sm:px-0 pt-[2.5rem] pb-0 sm:pt-[4.125rem] sm:pb-[4rem] relative">
        {/* Left Side - Text Content */}
        <div className="flex-1 flex flex-col sm:mt-0 max-w-[630px] w-full">
          {/* Vision Section */}
          {visionTitle && typeof visionTitle === "string" && (
            <div className="mb-[2.5rem]">
              <h3 className="text-xl font-bold text-[#333333] mb-4 uppercase leading-[1.625rem]">{visionTitle}</h3>
              {visionDescription && typeof visionDescription === "string" && (
                <p className="sm:text-base text-sm text-[#333333] sm:leading-[1.75rem] leading-[1.25rem]">
                  {visionDescription}
                </p>
              )}
            </div>
          )}

          {/* Mission Section */}
          {missionTitle && typeof missionTitle === "string" && (
            <div className="sm:mb-[0.9375rem] mb-0">
              <h3 className="text-xl font-bold text-[#333333] mb-4 uppercase leading-[1.5rem]">{missionTitle}</h3>
              {missionDescription && typeof missionDescription === "string" && (
                <p className="sm:text-base text-sm text-[#333333] sm:leading-[1.75rem] leading-[1.25rem]">
                  {missionDescription}
                </p>
              )}
            </div>
          )}

          {/* Company Values */}
          {companyValues && companyValues.length > 0 && (
            <div className="">
              {companyValues.map((value, index) => (
                <CompanyValueItem key={index} value={value} />
              ))}
            </div>
          )}

          {/* Image - Mobile only (full width below text) */}
          {imageUrl && (
            <div className="block sm:hidden w-full mt-6">
              <div className="relative w-full h-[300px] rounded-lg overflow-hidden">
                <Image src={imageUrl} alt="Bottom Section" fill className="object-cover" sizes="100vw" />
              </div>
            </div>
          )}
        </div>

        {/* Right Side - Image with absolute positioning - goes up (Desktop only) */}
        {imageUrl && (
          <div className="hidden sm:block absolute right-0 -top-[3.5rem] w-[600px] h-[489.5px]">
            <div className="relative w-full h-full rounded-lg overflow-hidden">
              <Image src={imageUrl} alt="Bottom Section" fill className="object-cover" sizes="507.5px" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
